export const validateTextContent = (content) => {
    if (!content) return false;
    const div = document.createElement('div');
    div.innerHTML = content;
    const text = div.textContent || div.innerText || '';
    return text.trim().length > 0;
}
